module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_02_6NX26_1SF_HV9.3ef0c8c1.jpg";